import React, { useState, useEffect } from "react";
import { Td, Tr } from "@lightspeed/cirrus-table";
import { Button } from "@lightspeed/flame/Button";
import { Input } from "@lightspeed/flame/Input";
import { Switch } from "@lightspeed/flame/Switch";
import { useDispatch, useSelector } from "react-redux";
import * as databaseActions from "../../../redux/actions/databaseActions";

const Row = ({ item, retail }) => {
  const dispatch = useDispatch();
  const ui = useSelector((state) => state.ui);
  const userState = useSelector((state) => state.userState);
  const database = useSelector((state) => state.database);

  const [edit, setEdit] = useState(false);
  const [changed, setChanged] = useState(false);

  const [inputBox1, setInputBox1] = useState(""); // account_id
  const [inputBox2, setInputBox2] = useState(""); // account_description
  const [checkBox3, setCheckBox3] = useState(false); // flashuz
  const [inputBox4, setInputBox4] = useState(""); // cogs
  const [inputBox5, setInputBox5] = useState(""); // cogs_description
  const [inputBox6, setInputBox6] = useState(""); // cogs2
  const [inputBox7, setInputBox7] = useState(""); // cogs_description2

  // NEW display-only values for added columns
  const classDeptLoc = item.class_department_location ?? "";
  const customer = item.qb_customer_id ?? "";

  const normalAccount = item.account_id ?? "";
  const normalAccountDescription = item.account_description ?? "";
  const normalCheck = item.flash === "Yes";
  const normalCogs = item.cogs ?? "";
  const normalCogsDescription = item.cogs_description ?? "";
  const normalCogs2 = item.cogs2 ?? "";
  const normalCogsDescription2 = item.cogs_description2 ?? "";

  useEffect(() => {
    setInputBox1(normalAccount);
    setInputBox2(normalAccountDescription);
    setCheckBox3(normalCheck);
    setInputBox4(normalCogs);
    setInputBox5(normalCogsDescription);
    setInputBox6(normalCogs2);
    setInputBox7(normalCogsDescription2);

    if (
      normalAccount === "" &&
      normalAccountDescription === "" &&
      normalCogs === "" &&
      normalCogsDescription === "" &&
      normalCogs2 === "" &&
      normalCogsDescription2 === ""
    ) {
      setEdit(true);
    } else {
      setEdit(false);
    }
  }, [
    normalAccount,
    normalAccountDescription,
    normalCogs,
    normalCogsDescription,
    normalCogs2,
    normalCogsDescription2,
    normalCheck,
  ]);

  useEffect(() => {
    // NOTE: vjerojatno si želio setChanged(false) dok je sve isto, a true kad je različito.
    const isSame =
      normalAccount === inputBox1 &&
      normalAccountDescription === inputBox2 &&
      normalCheck === checkBox3 &&
      normalCogs === inputBox4 &&
      normalCogsDescription === inputBox5 &&
      normalCogs2 === inputBox6 &&
      normalCogsDescription2 === inputBox7;

    setChanged(!isSame);
  }, [
    inputBox1,
    inputBox2,
    checkBox3,
    inputBox4,
    inputBox5,
    inputBox6,
    inputBox7,
    normalAccount,
    normalAccountDescription,
    normalCheck,
    normalCogs,
    normalCogsDescription,
    normalCogs2,
    normalCogsDescription2,
  ]);

  const handleUpdate = () => {
    dispatch(
      databaseActions.updateRetailCategory(
        userState.user.user_id,
        item.company_id,
        database.currentShop.shop_id,
        inputBox1,
        inputBox2,
        item.category_id,
        checkBox3 ? "Yes" : "",
        inputBox4,
        inputBox5,
        inputBox6,
        inputBox7,
        databaseActions.getShopCategories(
          database.currentCompany.id,
          userState.user.user_id,
          database.currentShop.shop_id
        )
      )
    );

    setEdit(false);
  };

  return (
    <Tr
      className={`${ui.theme === "flame" ? "" : "dark-table-row"}`}
      onDoubleClick={() => {
        setInputBox1(normalAccount);
        setInputBox2(normalAccountDescription);
        setCheckBox3(normalCheck);
        setInputBox4(normalCogs);
        setInputBox5(normalCogsDescription);
        setInputBox6(normalCogs2);
        setInputBox7(normalCogsDescription2);
        setEdit(true);
      }}
    >
      <Td>{item.company_id}</Td>
      <Td>{item.category_id}</Td>
      <Td>{item.category_name}</Td>
      {retail && <Td>{item.parentid}</Td>}

      {/* Account */}
      <Td>
        {!edit ? (
          <div className="row-input-wrapper">
            {inputBox1}
            <div className="flex" />
          </div>
        ) : (
          <div className="row-input-wrapper">
            <div>
              <Input
                className="input-wrapper-row-inputbox"
                type="text"
                size="small"
                value={inputBox1}
                onChange={(e) => setInputBox1(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleUpdate();
                }}
              />
            </div>
          </div>
        )}
      </Td>

      {/* Account Description */}
      <Td>
        {!edit ? (
          <div className="row-input-wrapper">
            {inputBox2}
            <div className="flex" />
          </div>
        ) : (
          <div className="row-input-wrapper">
            <div>
              <Input
                className="input-wrapper-row-inputbox"
                type="text"
                size="small"
                value={inputBox2}
                onChange={(e) => setInputBox2(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleUpdate();
                }}
              />
            </div>
          </div>
        )}
      </Td>

      {/* NEW: Class/Dep/Loc */}
      <Td>
        <div className="row-input-wrapper">
          {classDeptLoc}
          <div className="flex" />
        </div>
      </Td>

      {/* NEW: Customer */}
      <Td>
        <div className="row-input-wrapper">
          {customer}
          <div className="flex" />
        </div>
      </Td>

      {/* Flash */}
      <Td>
        <Switch
          checked={checkBox3}
          onChange={() => {
            setEdit(true);
            setCheckBox3((old) => !old);
          }}
        />
      </Td>

      {/* Cogs */}
      <Td>
        {!edit ? (
          <div className="row-input-wrapper">
            {inputBox4}
            <div className="flex" />
          </div>
        ) : (
          <div className="row-input-wrapper">
            <div>
              <Input
                className="input-wrapper-row-inputbox"
                type="text"
                size="small"
                value={inputBox4}
                onChange={(e) => setInputBox4(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleUpdate();
                }}
              />
            </div>
          </div>
        )}
      </Td>

      {/* Cogs Description */}
      <Td>
        {!edit ? (
          <div className="row-input-wrapper">
            {inputBox5}
            <div className="flex" />
          </div>
        ) : (
          <div className="row-input-wrapper">
            <div>
              <Input
                className="input-wrapper-row-inputbox"
                type="text"
                size="small"
                value={inputBox5}
                onChange={(e) => setInputBox5(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleUpdate();
                }}
              />
            </div>
          </div>
        )}
      </Td>

      {/* Cogs2 */}
      <Td>
        {!edit ? (
          <div className="row-input-wrapper">
            {inputBox6}
            <div className="flex" />
          </div>
        ) : (
          <div className="row-input-wrapper">
            <div>
              <Input
                className="input-wrapper-row-inputbox"
                type="text"
                size="small"
                value={inputBox6}
                onChange={(e) => setInputBox6(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleUpdate();
                }}
              />
            </div>
          </div>
        )}
      </Td>

      {/* Cogs Description2 */}
      <Td>
        {!edit ? (
          <div className="row-input-wrapper">
            {inputBox7}
            <div className="flex" />
          </div>
        ) : (
          <div className="row-input-wrapper">
            <div>
              <Input
                className="input-wrapper-row-inputbox"
                type="text"
                size="small"
                value={inputBox7}
                onChange={(e) => setInputBox7(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleUpdate();
                }}
              />
            </div>
          </div>
        )}
      </Td>

      {/* Action */}
      <Td textAlign="right">
        {!edit ? (
          <div className="row-input-wrapper-end">
            <Button
              onClick={() => {
                setInputBox1(normalAccount);
                setInputBox2(normalAccountDescription);
                setEdit(true);
              }}
              size="small"
              fill="true"
            >
              Edit
            </Button>
          </div>
        ) : (
          <div className="row-input-wrapper-end">
            {changed ? (
              <Button onClick={handleUpdate} size="small" fill="true">
                Update
              </Button>
            ) : inputBox1 === "" && inputBox2 === "" ? null : (
              <Button
                onClick={() => {
                  setInputBox1(normalAccount);
                  setInputBox2(normalAccountDescription);
                  setEdit(false);
                }}
                size="small"
                fill="true"
              >
                Cancel
              </Button>
            )}
          </div>
        )}
      </Td>
    </Tr>
  );
};

export default Row;
